<template>
  <li class="manage-list-row clearfix">
    <div class="job-info">
      <div class="job-img">
        <img :src="STATIC_URL + blog.thumb" class="attachment-thumbnail" alt="Thumb">
      </div>
      <div class="job-details">
        <h3 class="job-name"><a class="job_name_tag" href="javascript:void(0)">{{ blog.subject }}</a></h3>
        <small class="job-company"><i class="ti-home"></i>{{ blog.author }}</small>
        <small class="job-sallery"><i class="ti-time"></i>{{ blog.postDate }}</small>
        <div class="shortlisted-can">{{ getBlogCategory(blog.category) }}</div>
        
      </div>
    </div>
    <div class="job-buttons">
      <a href="javascript:void(0)" class="btn btn-blue manage-btn" @click="editBlog"><i class="ti-pencil"></i></a>
      <el-popconfirm
        :title="$t('website.blog.del-confirm')"
      >                   
        <a href="javascript:void(0)" class="btn btn-cancel manage-btn" slot="reference" @click="delBlog"><i class="ti-close"></i></a>
      </el-popconfirm>
    </div>
  </li>
</template>
<style>
</style>
<script>
// @ is an alias to /src
import moment from 'moment'

export default {
  name: 'Blog-Box',
  props: ['blog'],
  data: function() {
    return {
      
  	}
  },
  computed: {
    
  },
  methods: {
    editBlog: function() {
      this.$router.push({ path: '/blog/' + this.blog.id })
    },
    delBlog: function() {

    }
  },
  created: function() {
    
  }
}
</script>